import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Group } from '@mantine/core'
import { GeneralActionMenu } from '@/features/users/components/UserActionControls'
import { useUsersModel, useUsersPermissions, useUsersQueryMutations } from '@/features/users/hooks'
import { ExtendedUserType } from '@/features/users/types'
import { PATH, PATH_ADMIN, PATH_ADMIN_USERS, PATH_ADMIN_USERS_EDIT } from '@/routes/consts'

interface IProps {
  config?: {
    menu: boolean
  }
  user: ExtendedUserType
}

const defaultConfig = {
  menu: true,
}

export const Action = ({ user, config }: IProps) => {
  const { t } = useTranslation()

  const { id } = user

  const { isDeleted, isAdmin } = useUsersModel()
  const { isEditable } = useUsersPermissions()

  const menu = !isAdmin(user)

  config = {
    ...defaultConfig,
    ...config,
    menu,
  }

  const menuConfig = {
    remove: !isDeleted(user),
    restore: isDeleted(user),
    active: isEditable(user),
    edit: isEditable(user),
  }

  const { restore, active, remove } = useUsersQueryMutations()

  const getActionLoading = (data: { isLoading: boolean }) => data?.isLoading

  const loading = useMemo(() => {
    return getActionLoading(active) || getActionLoading(remove) || getActionLoading(restore)
  }, [getActionLoading(active), getActionLoading(remove), getActionLoading(restore)])

  const onActiveUpdate = async (params: { active: boolean }) => {
    await active.onActiveUpdate({ id, params })
  }

  const onRemove = async () => {
    await remove.onRemove(id)
  }

  const onRestore = async () => {
    await restore.onRestore(id)
  }

  return (
    <Group>
      {config.menu && (
        <GeneralActionMenu
          data={user}
          actionIconProps={{ loading }}
          menuProps={{ withinPortal: true }}
          editProps={{
            component: Link,
            to: `/${PATH.ADMIN}/${PATH_ADMIN.USERS}/${user?.id}/${PATH_ADMIN_USERS.EDIT}/${PATH_ADMIN_USERS_EDIT.PROFILE}`,
          }}
          config={menuConfig}
          removeProps={{ onRemove }}
          activeProps={{ onActiveUpdate }}
          restoreProps={{ onRestore }}
        />
      )}
    </Group>
  )
}
